export const INDENT_PER_DEPTH = 20;
